/* eslint-disable no-magic-numbers */
import { MAT_DATE_FORMATS } from '@angular/material/core';
import { Component, EventEmitter, Inject, inject, Input, Output } from '@angular/core';
import { FormControl } from '@angular/forms';
import { MatDatepickerInputEvent } from '@angular/material/datepicker';
import { Moment } from 'moment';
import { NGX_MAT_DATE_FORMATS } from '@ngxmc/datetime-picker';
import {
  CCOMX_DATE_FORMATS,
  DATE_WITH_TIME_DISPLAY,
  USE_DATE_TIME_FORMAT,
} from '../../../core/ccomx-date-formats';
import { validationMessages } from '../../messages';

@Component({
  selector: 'app-shared-ui-datepicker',
  templateUrl: './ui-datepicker.component.html',
  styleUrls: ['./ui-datepicker.component.scss'],
  providers: [
    {
      provide: MAT_DATE_FORMATS,
      useFactory: () => {
        return inject(USE_DATE_TIME_FORMAT) ? DATE_WITH_TIME_DISPLAY : CCOMX_DATE_FORMATS;
      },
    },
    {
      provide: NGX_MAT_DATE_FORMATS,
      useValue: DATE_WITH_TIME_DISPLAY,
    },
  ],
  standalone: false,
})
export class UiDatepickerComponent {
  @Input() label = '';
  @Input() description = '';
  @Input() control: FormControl;
  @Input() placeholder: string;
  @Input() messages = validationMessages;
  @Input() required = true;
  @Input() selected: boolean;
  @Input() min: Date | null;
  @Input() max: Date | null;
  @Input() initialTime: number[];
  @Input() tabIndex = 0;

  @Output() readonly changeHandler: EventEmitter<MatDatepickerInputEvent<Moment>> =
    new EventEmitter<MatDatepickerInputEvent<Moment>>();

  constructor(@Inject(USE_DATE_TIME_FORMAT) public useDateTimeFormat: boolean) {
    const date = new Date();
    this.initialTime = [date.getHours(), date.getMinutes(), date.getSeconds()];
  }

  setOpenedDate(datePicker: any): void {
    // fix for a bug in the datepicker https://github.com/h2qutc/angular-material-components/issues/356
    const dateCtrl: FormControl = this.control;
    const value =
      dateCtrl.value ||
      new Date(new Date().setHours(this.initialTime[0], this.initialTime[1], this.initialTime[2]));
    dateCtrl.setValue(value);
    // eslint-disable-next-line no-underscore-dangle
    datePicker._selected = value;
    datePicker.startAt = value;
  }
}
